/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */
//todo refactor delivery/pickup, map
define(
    [
        'jquery',
        'underscore',
        'assets/js/modules/View',
        'assets/js/modules/pages/start/view/pricingCalcItemView',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/designPreview/designPreview',
        'assets/js/modules/shippingCalendar',
        'assets/js/modules/GoogleMap',
        'assets/js/modules/utils',
        'assets/js/modules/browser',
        'assets/js/modules/screen',
        'assets/js/modules/translator',
        'moment',
        'selectboxit/src/javascripts/jquery.selectBoxIt.min'
    ],
    function(
        $,
        _,
        View,
        PricingCalcItemView,
        AttributeModel,
        OptionModel,
        OptionValueModel,
        designPreview,
        ShippingCalendar,
        GoogleMapPromise,
        utils,
        browser,
        screen,
        translator,
        moment
    ) {
        var CHOOSE_METHOD_TXT = '-- ' + translator.trans('start_page.delivery.choose_method', {}, 'start_page') + ' --';

        var CHOOSE_LOCATION_TXT = '-- ' + translator.trans('start_page.delivery.choose_location', {}, 'start_page') + ' --';
        var CHOOSE_LOCATION_FIRST_TXT = '-- ' + translator.trans('start_page.delivery.choose_location_first', {}, 'start_page') + ' --';
        var BITGIT_ABBR_TXT = translator.trans('start_page.delivery.bitgit_abbreviation', {}, 'start_page');
        var BITGIT_TXT = translator.trans('start_page.delivery.bitgit_long', {}, 'start_page');
        var PICKUP_TXT = translator.trans('start_page.delivery.pickup', {}, 'start_page');
        var BITGIT_PICKUP_TXT = translator.trans('start_page.delivery.bitgit_pickup', {}, 'start_page');
        const SHIPPING_METHOD_DELIVERY = 'delivery';
        const SHIPPING_METHOD_PICKUP = 'pickup';
        const AVAILABLE_SHIPPING_METHODS = [SHIPPING_METHOD_DELIVERY, SHIPPING_METHOD_PICKUP];

        // pricing metadata network service class - eventually this becomes its own class when the build is optimized
        // shipping data model extracted
        function ShippingMetadataService() {
            this._data = null;
        }

        ShippingMetadataService.prototype.setData = function(data) {
            this._data = data;
        };

        // shipping model accessors
        // gather unique set of pickup locations
        ShippingMetadataService.prototype.getPickupLocationsList = function() {
            var field = 'pickup_locations',
                locationKey = 'id',
                set = {};

            this._data.forEach(function(values) {
                if (Array.isArray(values[field])) {
                    values[field].forEach(function(location) {
                        set[location[locationKey]] = location;
                        location.inherited = {}; // temporarily pull in from parent record
                        location.inherited.date = values.date; // delivery date
                    });
                }
            });

            return Object.keys(set).map(function(k) {
                return set[k];
            });
        };

        // validation
        ShippingMetadataService.prototype.isDataLoaded = function() {
            return Array.isArray(this._data);
        };

        return View.extend({
            eventAgent: {},

            events: {
                'change #product-size-select': 'changeProduct',
                'change #delivery-or-pickup-select': 'onShippingMethodChange',
                'change #delivery': 'onDeliveryChange',
                'change #pickup-location': 'onPickupLocationChange',
                'change #pickup': 'onPickupChange'
            },

            initialize: function(options) {
                var _this = this;
                this.availableShipping = null;
                this.pickupMethods = [];
                this.map = null;

                this.pricingCalcView = null;
                this.eventAgent = this.model.get('eventAgent');

                this.$productSize = this.$el.find('#product-size-select');
                this.$sidesContainer = this.$el.find('#product-sides-select').closest('.product-choice');
                this.$price = this.$el.find('.total-charge');
                this.$pricingForm = this.$el.find('#opt-form');
                this.$deliveryTab = $('#pricing-delivery-tab-header');

                this.$zipInput = this.$el.find('#zip-code');
                this.$shippingMethod = this.$el.find('#delivery-or-pickup-select');
                this.$delivery = this.$el.find('#delivery');
                this.$pickup = this.$el.find('#pickup');
                this.$pickupLocation = this.$el.find('#pickup-location');
                this.$map = this.$el.find('#pickup-map');

                this.shippingMetadataService = new ShippingMetadataService(); // helps retrieve and manage pricing_shipping

                this.listenTo(this.eventAgent, {
                    'StartPage:setProducts': function() {
                        _this.renderProducts();
                    },
                    'StartPage:totalPriceUpdated': function(price) {
                        _this.updatePrice(price);
                    },
                    'StartPage:setPricingCalcItem': function() {
                        _this.initDesignPreview();
                    },
                    'StartPage:zipError': function(errorMessage) {
                        _this.showZipError(errorMessage);
                        _this.calendar.destroy();
                        if (_this.map) {
                            _this.map.clearMap();
                        }
                    },
                    'StartPage:zipValidated': function() {
                        _this.hideZipError();
                    },
                    'PricingCalculator:changed': function(pricingCalcItem, isSkuChanged, isOptionSetChanged, isSideCountChanged) {
                        _this.updateSubtotalPrice();
                        if (isOptionSetChanged || isSideCountChanged) {
                            _this.updateDesignPreview();
                        }
                    },
                    'PricingCalculator:shippingUpdated': function() {
                        _this.onShippingUpdate();
                    },
                    'PricingCalculator:shippingChanged': function() {
                        _this.updateShippingPrice();
                    }
                });

                this.listenTo(this.model, {
                    'change:pricingCalcItem': function() {
                        _this.changePricingCalcItemView();
                        _this.updateSubtotalPrice();
                        _this.updateDesignPreview();
                    }
                });

                this.listenTo(this.model.get('pricingCalc'), {
                    'pricingApi:shippingError': function() {
                        _this.showShippingError();
                    },
                    'pricingApi:shippingLoading': function() {
                        _this.onShippingLoading();
                    }
                });

                //Update prices on Zip change
                this.$pricingForm.on('submit', function(e) {
                    e.preventDefault();
                    _this.onPricingFormSubmit();
                });

                this.$zipInput.one('focus', function() {
                    if (!_this.map) {
                        _this.initMap();
                    }
                });

                /* Use 'mouseout' because 'click' working only with setTimeout */
                this.$deliveryTab.one('mouseout', function() {
                    _this.$el.find('select').selectBoxIt('refresh');
                });

                this.$el.find('select').selectBoxIt({ autoWidth: false });

                this.initCalendar();
            },

            initCalendar: function() {
                this.calendar = new ShippingCalendar({
                    parent: this,
                    showAllAvailableMonths: false,
                    clickable: true,
                    selectDriven: this.isSelectDriven(this.$delivery)
                });

                this.pickupCalendar = new ShippingCalendar({
                    parent: this,
                    showAllAvailableMonths: false,
                    clickable: true,
                    selectDriven: this.isSelectDriven(this.$pickup)
                });
            },

            renderProducts: function() {
                var selectedProductSlug = this.model.get('product').get('slug');
                var $productSizeContainer = this.$productSize.closest('.product-choice');
                if (this.model.get('products').length > 1) {
                    var productHtml = '';
                    this.model.get('products').each(function(product) {
                        var selected = product.get('slug') === selectedProductSlug;
                        productHtml +=
                            '<option value="' +
                            product.get('slug') +
                            '"' +
                            (selected ? ' selected' : '') +
                            '>' +
                            product.get('name') +
                            '</option>';
                    });
                    $productSizeContainer.removeClass('loading');
                    this.$productSize.html(productHtml);
                    this.$productSize.selectBoxIt('refresh');
                } else {
                    $productSizeContainer.hide();
                }
            },

            changePricingCalcItemView: function() {
                var pricingCalcItem = this.model.get('pricingCalcItem');
                if (pricingCalcItem.get('sides').length > 1) {
                    this.$sidesContainer.show();
                } else {
                    this.$sidesContainer.hide();
                }
                if (!this.pricingCalcView) {
                    this.pricingCalcView = this.getPricingCalcItemView();
                } else {
                    this.pricingCalcView.setModel(pricingCalcItem);
                }
            },

            /**
             * @return {PricingCalcItemView}
             */
            getPricingCalcItemView: function() {
                return new PricingCalcItemView({
                    model: this.model.get('pricingCalcItem'),
                    pricingCalc: this.model.get('pricingCalc'),
                    el: this.el,
                    pricingSetName: this.model.get('pricingCalc').get('pricingSetName')
                });
            },

            changeProduct: function(e) {
                var productSlug = $(e.target).val();
                this.model.trigger('product:beforeChange', productSlug);
            },

            initDesignPreview: function() {
                var pricingCalcItem = this.model.get('pricingCalcItem');
                var product = pricingCalcItem.get('product');
                var $dvvContainer = $('#dvvView-container');

                if ($dvvContainer.length === 0) {
                    return;
                }

                var availableSubstrates = [];
                var substrateOption = pricingCalcItem.getOption(OptionModel.NAME_SUBSTRATE);
                if (substrateOption) {
                    availableSubstrates = substrateOption.get('optionValues').map(function(pricingCalcOptionValue) {
                        return pricingCalcOptionValue.get('optionValue').get('name');
                    });
                }

                var previewWidth = product.getAttributeValue(AttributeModel.NAME_START_PAGE_WIDTH);
                var previewHeight = product.getAttributeValue(AttributeModel.NAME_START_PAGE_HEIGHT);
                var bleedRatio = previewWidth / previewHeight;

                designPreview.init(
                    {
                        productType: product.get('slug'),
                        productGroup: this.model.get('productGroup').get('slug'),
                        productSamples: product.get('samples'),
                        productShape: product.getAttributeValue(AttributeModel.NAME_SHAPE),
                        bleedRatio: bleedRatio,
                        availableSubstrates: availableSubstrates,
                        defaultOptions: product.getDefaultOptionValueNames(),
                        numOfSides: product.getAttributeValue(AttributeModel.NAME_MAX_SIDE_COUNT)
                    },
                    {
                        useSampleDesign: this.model.hasProductWithSamples(),
                        selectedOptions: {
                            backCoating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_COATING),
                            back_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_FOIL_COLOR),
                            filling: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FILLING) || 0,
                            folding: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FOLDING),
                            scoring: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SCORING),
                            frontCoating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_COATING),
                            front_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_FOIL_COLOR),
                            hole_making: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_HOLE_DRILLING),
                            rc: pricingCalcItem.getSelectedOptionValueName(OptionValueModel.NAME_ROUNDED_CORNERS),
                            substrate: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SUBSTRATE) || 0,
                            thickness: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_THICKNESS) || 0,
                            trimming: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_TRIMMING),
                            tShirtColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_COLOR),
                            tShirtSize: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_SIZE),
                            frontSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_SPOT_UV_COVERAGE),
                            backSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_SPOT_UV_COVERAGE),
                            uploadPattern: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_UPLOAD_PATTERN),
                            closure_type: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CLOSURE_TYPE),
                            caseColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CASE_COLOR)
                        }
                    },
                    {
                        dvvUrl: ONP.dvvUrl,
                        enlargePopup: true,
                        preloader: true
                    }
                );
            },

            updateDesignPreview: function() {
                var product = this.model.get('product');
                var previewWidth = product.getAttributeValue(AttributeModel.NAME_START_PAGE_WIDTH);
                var previewHeight = product.getAttributeValue(AttributeModel.NAME_START_PAGE_HEIGHT);
                var bleedRatio = previewWidth / previewHeight;
                var pricingCalcItem = this.model.get('pricingCalcItem');

                designPreview.trigger('change-design', {
                    productContext: {
                        slug: product.get('slug'),
                        samples: product.get('samples'),
                        shape: product.getAttributeValue(AttributeModel.NAME_SHAPE),
                        bleedRatio: bleedRatio
                    },
                    optionsContext: {
                        backCoating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_COATING),
                        back_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_FOIL_COLOR),
                        filling: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FILLING) || 0,
                        folding: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FOLDING),
                        frontCoating: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_COATING),
                        front_foil_color: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_FOIL_COLOR),
                        hole_making: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_HOLE_DRILLING) || 0,
                        rc: pricingCalcItem.getSelectedOptionValueName(OptionValueModel.NAME_ROUNDED_CORNERS),
                        substrate: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_SUBSTRATE) || 0,
                        thickness: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_THICKNESS) || 0,
                        trimming: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_TRIMMING),
                        tShirtColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_COLOR),
                        tShirtSize: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_T_SHIRT_SIZE),
                        frontSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_FRONT_SPOT_UV_COVERAGE),
                        backSpotUvCoverage: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_BACK_SPOT_UV_COVERAGE),
                        uploadPattern: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_UPLOAD_PATTERN),
                        closure_type: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CLOSURE_TYPE),
                        caseColor: pricingCalcItem.getSelectedOptionValueName(OptionModel.NAME_CASE_COLOR)
                    }
                });
            },

            /**
             * @return {undefined}
             */
            onPricingFormSubmit: function() {
                let _this = this;
                var zipVal = $.trim(this.$zipInput.val());
                if (zipVal === '') {
                    this.eventAgent.trigger('PricingCalculator:changeZip', null);
                    this.eventAgent.trigger('submitPricingForm');

                    return;
                }

                let promise = this.initMap();
                var lastPrediction = this.getLastAutocompletePrediction();
                if (lastPrediction !== null) {
                    zipVal = lastPrediction;
                    this.$zipInput.val(lastPrediction);
                }

                if (promise !== undefined) {
                    promise.then(function() {
                        _this.map.geoCodeAddress(zipVal);
                    });
                } else {
                    this.map.geoCodeAddress(zipVal);
                }
            },

            /**
             * @return {string|null}
             */
            getLastAutocompletePrediction: function() {
                var $autocompleteItem = $('.pac-container .pac-item').first();
                if ($autocompleteItem.length !== 0) {
                    var $query = $autocompleteItem.find('.pac-item-query');
                    var $additionalInfo = $query.next('span');

                    return $query.text() + ', ' + $additionalInfo.text();
                }

                return null;
            },

            updateSubtotalPrice: function() {
                var pricingCalcItem = this.model.get('pricingCalcItem');
                var regularPrice = pricingCalcItem.calculatePrice(true);
                var salePrice = pricingCalcItem.calculateSalePrice(true);

                var $regularPrice = this.$el.find('.regular-price');
                var $salePriceBox = this.$el.find('.sale-price-box');
                $regularPrice.text(utils.formatPrice(regularPrice, this.model.get('currency')));
                this.$el.find('.sale-price').text(utils.formatPrice(salePrice, this.model.get('currency')));
                if (regularPrice - salePrice < 0.00001) {
                    $salePriceBox.hide();
                    $regularPrice.removeClass('regular-price-has-sale');
                } else {
                    $salePriceBox.show();
                    $regularPrice.addClass('regular-price-has-sale');
                }
            },

            updatePrice: function(price) {
                if (!isNaN(price)) {
                    this.$price.text(utils.formatPrice(price, this.model.get('currency')));
                }
            },

            updateShippingPrice: function() {
                var shippingPrice = this.model.get('pricingCalc').get('shipping')
                    ? this.model.get('pricingCalc').get('shipping').price
                    : null;
                var $shippingPrice = this.$el.find('.shipping-cost .ship-handle-price');

                if (!isNaN(shippingPrice) && shippingPrice !== null) {
                    $shippingPrice.text(utils.formatPrice(shippingPrice, this.model.get('currency')));
                    this.$el.find('p.enter-zip, .plus-ship').hide();
                } else {
                    $shippingPrice.text('');
                    this.$el.find('p.enter-zip, .plus-ship').show();
                    this.$el.find('p.price.ship').hide();
                    this.$el.find('ul.delivery').empty();
                }
            },

            onShippingLoading: function() {
                this.$el
                    .find('.delivery-or-pickup-info')
                    .removeClass('active')
                    .hide();
                this.$el.find('#price-options .del-info').append('<span class="icon-spinner icon-spin icon-3x"></span>');
            },

            showShippingError: function() {
                this.$delivery.empty();
                $('<option />')
                    .text('Shipping information not available. Please try again later.')
                    .appendTo(this.$delivery);
            },

            onShippingMethodChange: function(e) {
                var $target = $(e.target);
                var $selectedOption = $target.find('option:selected');
                var shippingMethod = $selectedOption.attr('data-ship-method');

                var $shippingInfo = this.$el.find('.ship-msg');
                var $deliveryInfo = this.$el.find('.del-info');
                var $pickupInfo = this.$el.find('.pickup-info');

                if (shippingMethod === SHIPPING_METHOD_DELIVERY) {
                    $deliveryInfo.show();
                    $pickupInfo.hide();
                    $shippingInfo.show();
                    this.calendar.init({
                        $calendar: $('#calendar'),
                        $ulDelivery: $('#delivery')
                    });
                    this.pickupCalendar.destroy();
                    this.$delivery.trigger('change');
                    this.eventAgent.trigger('PricingCalculator:changeShipping', { method: shippingMethod });
                    this.$map.hide();
                } else if (shippingMethod === SHIPPING_METHOD_PICKUP) {
                    $deliveryInfo.hide();
                    $pickupInfo.show();
                    $shippingInfo.show();
                    this.calendar.destroy();
                    this.pickupCalendar.init({
                        $calendar: $('#pickupCalendar'),
                        $ulDelivery: $('#pickup')
                    });
                    this.$pickup.trigger('change');
                    this.eventAgent.trigger('PricingCalculator:changeShipping', { method: shippingMethod });
                    this.map.fitMap();
                } else {
                    $pickupInfo.hide();
                    $deliveryInfo.hide();
                    $shippingInfo.hide();
                    this.eventAgent.trigger('PricingCalculator:changeShipping');
                    this.calendar.destroy();
                    this.pickupCalendar.destroy();
                    this.$map.hide();
                }
            },

            onDeliveryChange: function(e) {
                // may be a select or ul with radio inputs
                var $target = $(e.currentTarget);
                var $selectedOption = $target.find('option:selected');
                if ($selectedOption.length === 0) {
                    $selectedOption = $target.find('input:checked');
                }

                var price = parseFloat($selectedOption.attr('data-ship-handle'));
                var date = $selectedOption.attr('data-date');
                this.$el.find('.p-del').show();
                this.$el.find('.p-pickup').hide();
                this.$el.find('span.ship-m').text(translator.trans('start_page.calculator.estimated_delivery', { date: date }));
                var $selectedMethod = this.$shippingMethod.find('option:selected');
                if (
                    $selectedMethod.length &&
                    $selectedMethod.attr('value') === undefined &&
                    this.$shippingMethod.attr('disabled') === undefined
                ) {
                    this.eventAgent.trigger('PricingCalculator:changeShipping');

                    return;
                }
                this.eventAgent.trigger('PricingCalculator:changeShipping', {
                    code: $selectedOption.data('shipping-carrier-service-code'),
                    date: date,
                    price: price,
                    category: $selectedOption.data('shipping-category'),
                    methodValue: $selectedOption.val()
                });
            },

            onPickupChange: function(e) {
                // may be a select or ul with radio inputs
                let $target = $(e.currentTarget);
                let $selectedOption = $target.find('option:selected');
                // reload googxle maps as a performance boost instead of at initial load
                let reloadMap = function() {
                    if ($selectedOption.length === 0) {
                        $selectedOption = $target.filter('input:checked');
                        var newMarker = this.map.getMarker($selectedOption.data('address'));
                        if (newMarker !== undefined) {
                            this.map.zoomMap(newMarker.getPosition());
                        } else {
                            this.map.fitMap();
                        }
                    }
                };

                let promise = this.initMap();
                if (promise !== undefined) {
                    promise.then(reloadMap);
                } else {
                    reloadMap();
                }

                this.$el.find('.p-del').hide();
                this.$el.find('.p-pickup').show();
                var price = parseFloat($selectedOption.attr('data-ship-handle'));
                var date = $selectedOption.data('date');
                var estimatedPickupText =
                    date !== undefined ? translator.trans('start_page.calculator.estimated_pickup', { date: date }, 'start_page') : '';
                this.$el.find('span.ship-m').text(estimatedPickupText);
                this.eventAgent.trigger('PricingCalculator:changeShipping', {
                    code: $selectedOption.data('shipping-carrier-service-code'),
                    date: date,
                    price: price,
                    category: $selectedOption.data('shipping-category'),
                    methodValue: $selectedOption.val()
                });
            },

            onPickupLocationChange: function(e) {
                var _this = this;
                var $target = $(e.target);
                var $selectedOption = $target.find('option:selected');
                var locationId = parseInt($selectedOption.val());
                var newMarker = this.map.getMarker(locationId);

                this.$pickup.selectBoxIt('remove');
                if (newMarker !== undefined) {
                    this.map.zoomMap(newMarker.getPosition());
                    this.$pickup.selectBoxIt('add', { text: CHOOSE_METHOD_TXT });
                } else {
                    this.map.fitMap();
                    this.$pickup.selectBoxIt('add', { text: CHOOSE_LOCATION_FIRST_TXT });
                }

                if (isNaN(locationId)) {
                    locationId = 1;
                    this.$el.find('#pickup').trigger('change');
                }

                this.pickupMethods.forEach(function(method) {
                    if (method.pickupLocationId === locationId) {
                        _this.$pickup.selectBoxIt('add', method.pickupMethod);
                    }
                });

                this.pickupCalendar.init({
                    $calendar: $('#pickupCalendar'),
                    $ulDelivery: $('#pickup')
                });
                this.eventAgent.trigger('PricingCalculator:changeShipping', { location: locationId });
            },

            //todo move logic to controller
            onShippingUpdate: function() {
                var _this = this;
                var availableShipping = this.model.get('pricingCalc').get('availableShipping');
                var lastChosenShipping = _.clone(_this.model.get('pricingCalc').get('shipping'));
                this.shippingMetadataService.setData(availableShipping);
                if (this.map) {
                    this.map.clearMap();
                }
                this.pickupMethods = [];
                var showDeliveryOrPickupSelect = false;

                var currentShipping = {
                    date: null,
                    optionIndex: 0
                };

                const shippingIsAvailable = AVAILABLE_SHIPPING_METHODS.includes(this.$shippingMethod.val());
                if (shippingIsAvailable && this.$delivery.val()) {
                    currentShipping.date = this.$delivery.find('option:selected').val();
                    currentShipping.optionIndex = this.$delivery.find('option:selected').index();
                }

                // Clear out both the pickup select and delivery select
                if (this.isSelectDriven(this.$pickup)) {
                    this.$pickup.selectBoxIt('remove');
                } else {
                    this.$pickup.empty();
                }

                if (this.isSelectDriven(this.$pickupLocation)) {
                    this.$pickupLocation.selectBoxIt('remove');
                }

                if (this.isSelectDriven(this.$delivery)) {
                    this.$delivery.selectBoxIt('remove');
                } else {
                    this.$delivery.empty();
                }

                var singlePickupLocation = true;
                $.each(availableShipping, function(key, value) {
                    if ('pickup_locations' in value && value.pickup_locations.length > 1) {
                        singlePickupLocation = false;
                    }
                });

                var $pickupLocationContainer = this.$el.find('#pickup-location-container');
                if (singlePickupLocation || !this.isSelectDriven(this.$pickupLocation)) {
                    $pickupLocationContainer.hide();
                } else {
                    $pickupLocationContainer.show().removeClass('hidden');
                    if (this.$pickup.length) {
                        this.$pickup.selectBoxIt('remove');
                        this.$pickup.selectBoxIt('add', { text: CHOOSE_LOCATION_FIRST_TXT });
                    }

                    if (this.$pickupLocation.length) {
                        this.$pickupLocation.selectBoxIt('remove');
                        this.$pickupLocation.selectBoxIt('add', { text: CHOOSE_LOCATION_TXT });
                    }
                }

                $.each(availableShipping, function(key, value) {
                    let deliveryDate = moment(value.date, 'ddd, DD-MMM YYYY').format('MM/DD/YYYY');
                    // Adding VAT to shipping cost
                    let shipCost =
                        _this.model.get('pricingCalc').applyVatToPrice(parseFloat(value.shipping_cost)) +
                        _this.model.get('pricingCalc').applyVatToPrice(parseFloat(value.handling_cost));
                    let formattedShipCost = utils.formatPrice(shipCost, _this.model.get('currency'));
                    let descriptionText = '';
                    let descriptionHtml = '';

                    if (value.category === 'Rush') {
                        descriptionHtml = '<abbr title="' + BITGIT_TXT + '">' + BITGIT_ABBR_TXT + '</abbr>&trade; ';
                        descriptionText = BITGIT_ABBR_TXT;
                    }

                    var estimatedDeliveryText = translator.trans(
                        'start_page.calculator.estimated_delivery',
                        { date: deliveryDate },
                        'start_page'
                    );

                    var shipHtml = descriptionHtml + formattedShipCost + ', <em>' + estimatedDeliveryText + '</em>';
                    var shipText = descriptionText + formattedShipCost + ', ' + estimatedDeliveryText;

                    if ('pickup_locations' in value && value.pickup_locations.length > 0) {
                        var categoryTitle = '';

                        switch (value.category) {
                            case 'In Store Pickup':
                                categoryTitle = PICKUP_TXT + ': ';
                                break;
                            case 'In Store Pickup - Ships Today':
                                categoryTitle =
                                    '<abbr title="' + BITGIT_TXT + '">' + BITGIT_ABBR_TXT + '</abbr>&trade; ' + PICKUP_TXT + ' : ';
                                break;
                        }

                        $.each(value.pickup_locations, function(key2, pickupLocation) {
                            var pickupHtml = categoryTitle + ' ' + formattedShipCost + ', <em>' + estimatedDeliveryText;
                            if (singlePickupLocation || !_this.$pickup.length) {
                                pickupHtml =
                                    pickupHtml +
                                    ' (' +
                                    pickupLocation.address1 +
                                    ', ' +
                                    pickupLocation.city +
                                    ', ' +
                                    pickupLocation.state +
                                    ')';
                            }
                            pickupHtml = pickupHtml + '</em>';
                            showDeliveryOrPickupSelect = true;

                            var pickupMethod = {
                                value: pickupLocation.address1 + '_' + deliveryDate,
                                text: pickupLocation.display_name + ' ' + formattedShipCost + ', ' + estimatedDeliveryText,
                                'data-text': pickupHtml,
                                'data-date': deliveryDate,
                                'data-ship-handle': shipCost,
                                'data-shipping-carrier-service-code': value.shipping_carrier_service_code,
                                'data-shipping-category': value.category,
                                'data-address': pickupLocation.one_line_address,
                                'data-store-hours': pickupLocation.store_hours,
                                'data-location-id': pickupLocation.id,
                                'data-location-postal-code': pickupLocation.postal_code
                            };

                            _this.pickupMethods.push({
                                pickupLocationId: pickupLocation.id,
                                pickupMethod: pickupMethod
                            });

                            if (_this.isSelectDriven(_this.$pickup)) {
                                if (singlePickupLocation) {
                                    _this.$pickup.selectBoxIt('add', pickupMethod);
                                } else {
                                    if (
                                        _this.$pickupLocation.length &&
                                        !_this.$pickupLocation.find('option[value=' + pickupLocation.id + ']').length
                                    ) {
                                        _this.$pickupLocation.selectBoxIt('add', {
                                            value: pickupLocation.id,
                                            text: pickupLocation.one_line_address,
                                            'data-address': pickupLocation.one_line_address
                                        });
                                    }
                                }
                            } else {
                                pickupMethod =
                                    '<li>' +
                                    '<label class="radio">' +
                                    '<input type="radio" name="del" data-location-id ="' +
                                    pickupLocation.id +
                                    '" data-date="' +
                                    deliveryDate +
                                    '" data-ship-handle="' +
                                    shipCost +
                                    '" data-address="' +
                                    pickupLocation.one_line_address +
                                    '" data-store-hours="' +
                                    pickupLocation.store_hours +
                                    '" />' +
                                    pickupHtml +
                                    '</label>' +
                                    '</li>';
                                _this.$pickup.append(pickupMethod);
                            }
                        });

                        // update marks if only changing the zip when the map already rendered
                        if (_this.map) {
                            _this.initMapMarker();
                        }
                    } else {
                        if (_this.isSelectDriven(_this.$delivery)) {
                            _this.$delivery.selectBoxIt('add', {
                                value: deliveryDate,
                                text: shipText,
                                'data-text': shipHtml,
                                'data-date': deliveryDate,
                                'data-ship-handle': shipCost,
                                'data-shipping-carrier-service-code': value.shipping_carrier_service_code,
                                'data-shipping-category': value.category
                            });
                        } else {
                            var shipMethod =
                                '<li>' +
                                '<label class="radio">' +
                                '<input type="radio" name="del" data-date="' +
                                deliveryDate +
                                '" data-ship-handle="' +
                                shipCost +
                                '" />' +
                                shipHtml +
                                '</label>' +
                                '</li>';

                            _this.$delivery.append(shipMethod);
                        }
                    }
                });

                if (showDeliveryOrPickupSelect) {
                    this.$el
                        .find('.delivery-or-pickup-info')
                        .addClass('active')
                        .show();
                    this.$shippingMethod.removeAttr('disabled');
                    if (this.$zipInput.data('pickup-preseted')) {
                        this.selectValue(this.$shippingMethod, 'pickup');
                        this.$zipInput.data('pickup-preseted', false);
                        this.map.fitMap();
                    }
                    this.$shippingMethod.trigger('change');
                    this.$shippingMethod.selectBoxIt('refresh');
                } else {
                    this.$el
                        .find('.delivery-or-pickup-info')
                        .removeClass('active')
                        .hide();
                    this.$shippingMethod.attr('disabled', 'disabled');
                    this.$el.find('.pickup-info').hide();
                    this.$el.find('.del-info').show();
                    if (this.map) {
                        this.map.clearMap();
                    }
                    this.pickupCalendar.destroy();
                    this.calendar.init({
                        $calendar: $('#calendar'),
                        $ulDelivery: $('#delivery')
                    });
                    if (currentShipping.date === null) {
                        this.$delivery.trigger('change');
                    }
                }

                if (currentShipping.date !== null) {
                    if (this.$delivery.find('option[value="' + currentShipping.date + '"]').length !== 0) {
                        this.$delivery.find('option[value="' + currentShipping.date + '"]').prop('selected', true);
                    } else if (currentShipping.optionIndex > 0) {
                        this.$delivery
                            .find('option')
                            .eq(currentShipping.optionIndex - 1)
                            .prop('selected', true);
                    }
                    this.$delivery.trigger('change');
                }

                if (lastChosenShipping) {
                    if (lastChosenShipping.method) {
                        this.$shippingMethod.find('option[value="' + lastChosenShipping.method + '"]').prop('selected', true);
                        this.$shippingMethod.trigger('change');
                    } else {
                        this.model.get('pricingCalc').dropShipping();
                    }

                    if (lastChosenShipping.method === 'pickup') {
                        this.$pickupLocation.find('option[value="' + lastChosenShipping.location + '"]').prop('selected', true);
                        this.$pickupLocation.trigger('change');
                        this.$pickup.find('option[value="' + lastChosenShipping.methodValue + '"]').prop('selected', true);
                        this.$pickup.trigger('change');
                    } else {
                        this.$delivery.find('option[value="' + lastChosenShipping.methodValue + '"]').prop('selected', true);
                        this.$delivery.trigger('change');
                    }
                }

                this.$el.find('.icon-spinner').remove();
            },

            initMap: function() {
                var _this = this;
                if (!this.map && this.$map.length) {
                    GoogleMapPromise.then(function(GoogleMap) {
                        _this.map = new GoogleMap(
                            _this.$map.attr('id'),
                            {},
                            {
                                zoom: 5,
                                maxZoom: null,
                                minZoom: null,
                                draggable: true,
                                zoomControl: true,
                                scrollwheel: true,
                                disableDoubleClickZoom: false,
                                disableDefaultUI: true,
                                keyboardShortcuts: false
                            }
                        );

                        // check if fetched data ready, apply correct map
                        if (_this.shippingMetadataService.isDataLoaded()) {
                            _this.initMapMarker();
                        }
                        _this.map.on({
                            'GoogleMap:locationFound': function(zip) {
                                _this.eventAgent.trigger('PricingCalculator:changeZip', zip);
                                _this.eventAgent.trigger('submitPricingForm');
                            },
                            'GoogleMap:error': function(errorText) {
                                _this.showZipError(errorText);
                            }
                        });
                    });

                    return GoogleMapPromise;
                }
            },

            // prepare map markers, assuming shipping data preloaded. supports updating mode
            initMapMarker: function() {
                var _this = this;

                this.shippingMetadataService.getPickupLocationsList().forEach(function(pickupLocation) {
                    if (_this.map.getMarker(pickupLocation.id)) {
                        return;
                    }

                    _this.map.setMarker(pickupLocation.id, pickupLocation.location, true);

                    // jumps to map zoom detail on that address
                    _this.map.handleClickPickupLocation(
                        _this.map.getMarker(pickupLocation.id),
                        pickupLocation.address1 + ', ' + pickupLocation.city + ', ' + pickupLocation.state,
                        _this.$pickupLocation,
                        pickupLocation.id
                    );
                });

                this.map.fitMap();
            },

            showZipError: function(errorText) {
                var $label = this.$el.find('label[for="zip-code"]');
                if (!$label.length) {
                    $label = $('<label>')
                        .addClass('error')
                        .attr('for', 'zip-code')
                        .attr('generated', 'true');
                    this.$el.find('#zip-btn').after($label);
                }

                $label.text(errorText).show();
                this.$zipInput.addClass('error');
            },

            hideZipError: function() {
                var $label = this.$el.find('label[for="zip-code"]');
                if ($label.length) {
                    $label.hide();
                }
            },

            /**
             * selects native select value and refreshes selectBoxIt
             * needed to avoid 'change' event to be fired by selectOption
             */
            selectValue: function($element, value) {
                $element.val(value);
                $element.selectBoxIt('refresh');
            },

            isSelectDriven: function($element) {
                return $element.length && !$element.hasClass('radio');
            }
        });
    }
);
